module.exports = __webpack_public_path__ + "media/application/images/icons/topics-water-efficiency-pebble-dark-green-rgb-a8837a66c69f1f3cec33e3abb65a0ba5.svg";